<template>
  <div class="recommended-reading">
    <ul class="recommended-reading__list list-reset">
      <li
        v-for="post in posts"
        :key="`recommended-${post.id}`"
        class="recommended-reading__item"
      >
        <recommended-reading-teaser :post="post" />
      </li>
    </ul>
  </div>
</template>

<script>
import RecommendedReadingTeaser from '@/components/Posts/RecommendedReadingTeaser.vue';

export default {
  name: 'RecommendedReading',
  components: { RecommendedReadingTeaser },
  props: {
    posts: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_recommended-reading';
</style>

<docs>

This component is used in the ContentRenderer to build out a recommended reading
section.

The recommended reading section displays up to 5 posts that are curated via the
wordpress admin. This component is not connected to any algorithmic recommendations.

</docs>
